import { parseJSON } from '../utils/api';
import { SubmissionError } from 'redux-form';
import InPlayer from '@inplayer-org/inplayer.js';

export const SUBSCRIBE_REQUEST = 'SUBSCRIBE_REQUEST';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_FAILURE = 'SUBSCRIBE_FAILURE';
export const SUBSCRIBE_SUBMITTED = 'SUBSCRIBE_SUBMITTED';

export const subscribe = paymentObj => {
    return async (dispatch, getState) => {
        const payment = getState().payments;
        if (payment.isProcessing || payment.isSubmitted) {
            return null;
        }

        dispatch({ type: SUBSCRIBE_REQUEST });

        const paymentObject = {
            number: paymentObj.cardNumber,
            cardName: paymentObj.cardName,
            expMonth: paymentObj.expiryValue
                ? paymentObj.expiryValue.month
                : '',
            expYear: paymentObj.expiryValue ? paymentObj.expiryValue.year : '',
            cvv: paymentObj.cvc,
            accessFee: paymentObj.selectedFee.id,
            paymentMethod: paymentObj.paymentMethod,
            referrer: paymentObj.referrer,
        };

        if (paymentObj.voucherCode) {
            paymentObject.voucherCode = paymentObj.voucherCode;
        }

        try {
            InPlayer.Subscription.assetSubscribe(
                InPlayer.Account.getToken().token,
                paymentObject
            ).then(data => {
                dispatch({
                    type: SUBSCRIBE_SUBMITTED,
                    data,
                    id: paymentObj.assetID,
                });
            });
        } catch (error) {
            let data = await parseJSON(error.response);
            dispatch({ type: SUBSCRIBE_FAILURE });
            throw new SubmissionError({ _error: data, ...data.errors });
        }
    };
};

export const GET_SUBSCRIPTIONS_REQUEST = 'GET_SUBSCRIPTIONS_REQUEST';
export const GET_SUBSCRIPTIONS_SUCCESS = 'GET_SUBSCRIPTIONS_SUCCESS';
export const GET_SUBSCRIPTIONS_FAILURE = 'GET_SUBSCRIPTIONS_FAILURE';

//TODO: check if same page and optimize maybe?
export const fetchSubscriptions = (isInitial, page, limit = 5) => {
    return (dispatch, getState) => {
        dispatch({ type: GET_SUBSCRIPTIONS_REQUEST });

        try {
            InPlayer.Subscription.getSubscriptions(
                InPlayer.Account.getToken().token,
                limit,
                page
            ).then(data => {
                dispatch({
                    type: GET_SUBSCRIPTIONS_SUCCESS,
                    payload: {
                        data: data,
                        isInitial: isInitial,
                        page: page,
                    },
                });
            });
        } catch (e) {
            dispatch({ type: GET_SUBSCRIPTIONS_FAILURE });
        }
    };
};

export const CANCEL_SUBSCRIPTION_REQUEST = 'CANCEL_SUBSCRIPTION_REQUEST';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_SUBSCRIPTION_FAILURE';

export const cancelSubscription = (url, callback) => {
    return dispatch => {
        dispatch({
            type: CANCEL_SUBSCRIPTION_REQUEST,
            payload: {
                data: url,
            },
        });

        try {
            InPlayer.Subscription.cancelSubscription(
                url,
                InPlayer.Account.getToken().token
            ).then(data => {
                dispatch({
                    type: CANCEL_SUBSCRIPTION_SUCCESS,
                    payload: {
                        data: url,
                    },
                });
                if (callback) callback();
            });
        } catch (e) {
            dispatch({ type: CANCEL_SUBSCRIPTION_FAILURE });
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/subscriptions.js